// API Configuration
export const API_CONFIG = {
  BASE_URL: 'http://localhost:8000/api',
  TIMEOUT: 30000, // Increased timeout to 30 seconds
  HEADERS: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
} as const;

// Environment-specific configuration
export const getApiUrl = (): string => {
  // Check for environment variable first
  const envApiUrl = (import.meta as any).env?.VITE_API_URL;
  if (envApiUrl) {
    return envApiUrl;
  }
  
  // Auto-detect production environment
  const isProduction = window.location.hostname !== 'localhost' && 
                      window.location.hostname !== '127.0.0.1' &&
                      !window.location.hostname.includes('localhost');
  
  if (isProduction) {
    // In production, use the same domain with /api prefix
    return `${window.location.protocol}//${window.location.host}/api`;
  }
  
  // Default to localhost for development
  return API_CONFIG.BASE_URL;
};
